<template>
  <!-- 加班申请 -->
  <div>
    <Collapse v-model="value2" simple :disabled="prevent" style="border: 0">
      <Panel name="1" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle
          :titleText="
            lang == 'zh' ? chName.BasicInformation : enName.BasicInformation
          "
        />
        <Form
          slot="content"
          :label-width="150"
          label-position="left"
          class="titleDistance"
          :disabled="prevent"
          style="margin-top: 30px"
        >
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.createTime : enName.createTime"
              >
                <Input disabled v-model="formItem.applyDate" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="lang == 'zh' ? chName.applyNo : enName.applyNo">
                <Input disabled v-model="formItem.applyNo" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7"> </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.applyName : enName.applyName"
              >
                <Input disabled v-model="formItem.userName" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.applyUserId : enName.applyUserId"
              >
                <Input disabled v-model="formItem.applyUserId" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="
                  lang == 'zh' ? chName.applyPosition : enName.applyPosition
                "
              >
                <Input disabled v-model="formItem.positionName" />
              </FormItem>
            </Col>
          </Row>
          <!-- <Row type="flex" justify="space-between">
                <Col :xs="24" :sm="24" :md="24" :lg="7">
                  <FormItem label="公司">
                     <Input disabled v-model="formItem.orgsname2"/>
                  </FormItem>
                </Col>                
                <Col :xs="24" :sm="24" :md="24" :lg="7">
                  <FormItem label="地区">
                     <Input disabled v-model="formItem.orgsname4"/>
                  </FormItem>
                </Col>
                <Col :xs="24" :sm="24" :md="24" :lg="7">
                  <FormItem label="部门">
                    <Input disabled v-model="formItem.orgsname5"/>
                  </FormItem>
                </Col>
            </Row> -->
        </Form>
      </Panel>
      <Panel name="2" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle
          :titleText="
            lang == 'zh'
              ? chName.OvertimeApplicationInformation
              : enName.OvertimeApplicationInformation
          "
        />
        <Form
          slot="content"
          :label-width="150"
          label-position="left"
          class="titleDistance"
          :disabled="prevent"
          :model="formItem"
          :rules="rules"
          ref="formItem"
        >
          <!-- <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="申请类型">
                <RadioGroup v-model="formItem.applyType" type="button">
                  <Radio :label="item.code" v-for="item in applyTypeList" :key="item.code" :disabled="isHistory">
                    <span>{{ item.name }}</span>
                  </Radio>
                </RadioGroup>
              </FormItem>
            </Col>
          </Row> -->
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.p_begin_dt : enName.p_begin_dt"
                prop="p_begin_dt"
              >
                <DatePicker
                  :editable="false"
                  type="date"
                  v-model="formItem.p_begin_dt"
                  :disabled="isHistory"
                  @on-change="getDateChange()"
                  style="width:100%"
                ></DatePicker>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.p_begin_tm : enName.p_begin_tm"
              >
                <TimePicker
                  :editable="false"
                  format="HH:mm"
                  :steps="[1, 30]"
                  v-model="formItem.p_begin_tm"
                  style="width:100%"
                  :disabled="isHistory"
                  @on-change="getDateChange"
                ></TimePicker>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="lang == 'zh' ? chName.otType : enName.otType">
                <Select
                  v-model="formItem.otType1"
                  :clearable="true"
                  placeholder=""
                  disabled
                >
                  <Option
                    :value="item.code"
                    v-for="(item, i) in overTimeTypeList"
                    :key="i"
                    >{{ item.name }}
                  </Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.p_end_dt : enName.p_end_dt"
                prop="p_end_dt"
              >
                <DatePicker
                  :editable="false"
                  type="date"
                  v-model="formItem.p_end_dt"
                  :disabled="isHistory"
                  style="width:100%"
                  @on-change="getDateChange"
                ></DatePicker>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="lang == 'zh' ? chName.p_end_tm : enName.p_end_tm"
              >
                <TimePicker
                  :editable="false"
                  format="HH:mm"
                  :steps="[1, 30]"
                  v-model="formItem.p_end_tm"
                  :disabled="isHistory"
                  style="width:100%"
                  @on-change="getDateChange"
                ></TimePicker>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem :label="lang == 'zh' ? chName.otType : enName.otType">
                <Select
                  v-model="formItem.otType2"
                  :clearable="true"
                  placeholder=""
                  disabled
                >
                  <Option
                    :value="item.code"
                    v-for="(item, i) in overTimeTypeList"
                    :key="i"
                    >{{ item.name }}
                  </Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem
                :label="
                  lang == 'zh' ? chName.overTimeLength : enName.overTimeLength
                "
              >
                <Input v-model="formItem.overTimeLength" disabled />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <Button @click="getOverTimeHour" v-show="!isHistory">{{
                lang == "zh"
                  ? chName.calculateOvertimeHours
                  : enName.calculateOvertimeHours
              }}</Button>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7"> </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col span="24">
              <FormItem :label="lang == 'zh' ? chName.nvchr1 : enName.nvchr1">
                <Input
                  type="textarea"
                  v-model="formItem.nvchr1"
                  :disabled="isHistory"
                />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Panel>
      <Panel name="3" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle
          :titleText="
            lang == 'zh'
              ? chName.actualCardSwipingInformation
              : enName.actualCardSwipingInformation
          "
        />
        <Table
          height="300"
          slot="content"
          border
          :columns="punishmentColumns"
          :data="punishmentData"
          class="titleDistance"
          :loading="loading"
        >
        </Table>
        <div
          slot="content"
          style="display:flex; margin: 10px 30px 0 0;justify-content:flex-end"
        >
          <Page :total="total" @on-change="pageChange" />
        </div>
      </Panel>
    </Collapse>
    <Row class="btnRight">
      <Col>
        <Button class="applyBtnRight" v-if="!isHistory" @click="importCG">{{
          lang == "zh" ? chName.importDraft : enName.importDraft
        }}</Button>
        <Button class="applyBtnRight" v-if="!isHistory" @click="saveCG">{{
          lang == "zh" ? chName.savetDraft : enName.savetDraft
        }}</Button>
        <Button class="applyBtnRight" v-if="!isHistory" @click="submitt">{{
          lang == "zh" ? chName.submit : enName.submit
        }}</Button>
        <Button class="applyBtnRight" @click="returnPage">{{
          lang == "zh" ? chName.return : enName.return
        }}</Button>
      </Col>
    </Row>
    <!-- 草稿模板列表 -->
    <j2-DraftTemplate ref="cgTem" @getCGDa="getCGDa1" />
    <j2-DraftPop ref="cgPop" />
    <!-- 审批历史 -->
    <div v-if="isHistory" style="margin-left:16px">
      <FormTitle
        :titleText="
          lang == 'zh' ? chName.approvalhistory : enName.approvalhistory
        "
        style="margin-top: 30px"
      />
      <Table border :columns="columns1" :data="data1" class="titleDistance">
      </Table>
    </div>
    <Spin size="large" fix v-if="spinShow"></Spin>
  </div>
</template>
<script>
import axios from "axios";
import DateUtil from "../../../util/DateUtil";
export default {
  data() {
    const checkStartDt = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请选择预定加班开始日期"));
      } else {
        if (this.formItem.p_end_dt) {
          let datetime1 = new Date(value).getTime();
          let datetime2 = new Date(this.formItem.p_end_dt).getTime();
          if (datetime1 > datetime2) {
            callback(new Error("预定加班开始日期不得大于结束时间"));
          } else if (datetime1 + 86400000 < datetime2) {
            console.log(datetime1 + 86400000, datetime2, "123");
            callback(new Error("预定加班开始日期不得早于结束时间-1天"));
          } else {
            callback();
          }
        } else {
          callback();
        }
      }
    };
    const checkEndDt = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请选择预定加班结束日期"));
      } else {
        if (this.formItem.p_begin_dt) {
          let datetime1 = new Date(this.formItem.p_begin_dt).getTime();
          let datetime2 = new Date(value).getTime();
          if (datetime1 > datetime2) {
            callback(new Error("预定加班开始日期不得大于结束时间"));
          } else if (datetime1 + 86400000 < datetime2) {
            callback(new Error("预定加班结束日期不得早于开始时间+1天"));
          } else {
            callback();
          }
        } else {
          callback();
        }
      }
    };
    return {
      rules: {
        p_begin_dt: [
          { required: true, message: "请选择预定加班开始日期" },
          { required: true, validator: checkStartDt }
        ],
        p_end_dt: [
          { required: true, message: "请选择预定加班结束日期" },
          { required: true, validator: checkEndDt }
        ]
      },
      options1: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      date: new DateUtil(),
      value2: [1, 2, 3],
      formItem: {
        applyDate: "",
        status: "",
        nvchr1: "",
        nvchr2: ""
      },
      prevent: false,
      data1: [],
      overTimeTypeList: [{ name: "工作日加班", code: "1" }],
      // applyTypeList: [
      //   { name: "正常申请", code: "1" },
      //   { name: "过期补申请", code: "0" },
      // ],
      isHistory: false,
      spinShow: false,
      p_begin_tm: "",
      p_end_tm: "",
      chName: {},
      enName: {},
      punishmentData: [],
      pageInfo: {
        itemCount: 0,
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      loading: false
    };
  },
  created() {
    if (this.getQueryVariable("history")) {
      this.isHistory = true;
    }
    // 查询国际化
    this.getInternation();
  },
  watch: {
    "formItem.p_begin_dt"(val) {
      if (!this.isHistory) {
        if (this.formItem.p_begin_dt && this.formItem.p_end_dt) {
          this.formItem.otType1 = "1";
          this.formItem.otType2 = "1";
          if (this.formItem.p_end_dt != "") {
            this.$refs["formItem"].fields.forEach(e => {
              if (e._props.prop == "p_end_dt") {
                e.validate();
              }
            });
          }
        } else {
          this.formItem.otType1 = "";
          this.formItem.otType2 = "";
        }
      }
    },
    "formItem.p_end_dt"(val) {
      if (!this.isHistory) {
        if (this.formItem.p_begin_dt && this.formItem.p_end_dt) {
          this.formItem.otType1 = "1";
          this.formItem.otType2 = "1";
          if (this.formItem.p_begin_dt != "") {
            this.$refs["formItem"].fields.forEach(e => {
              if (e._props.prop == "p_begin_dt") {
                e.validate();
              }
            });
          }
        } else {
          this.formItem.otType1 = "";
          this.formItem.otType2 = "";
        }
      }
    }
  },
  mounted() {
    this.getEmpDate();
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    },
    columns1() {
      return [
        {
          title:
            this.lang == "zh" ? this.chName.stepName : this.enName.stepName,
          key: "stepName",
          align: "center",
          width: "280"
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.approvalperson
              : this.enName.approvalperson,
          key: "userName",
          align: "center",
          width: "280"
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.approvaltime
              : this.enName.approvaltime,
          key: "time",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.time, "YYYY-MM-DD HH:mm")
            );
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.approvalstatus
              : this.enName.approvalstatus,
          key: "status",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              params.row.status == "0"
                ? "通过"
                : params.row.status == "1"
                ? "驳回"
                : ""
            );
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chName.approvalopinions
              : this.enName.approvalopinions,
          key: "message",
          align: "center",
          width: "465"
        }
      ];
    },
    punishmentColumns() {
      return [
        {
          title: this.lang == "zh" ? this.chName.date : this.enName.date,
          key: "date",
          align: "center"
        },
        {
          title:
            this.lang == "zh" ? this.chName.workhourid : this.enName.workhourid,
          key: "workhourid",
          align: "center"
        },
        {
          title: this.lang == "zh" ? this.chName.inorout : this.enName.inorout,
          key: "inorout",
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              params.row.inorout == "1"
                ? "出"
                : params.row.inorout == "0"
                ? "进"
                : null
            );
          }
        },
        {
          title: this.lang == "zh" ? this.chName.time : this.enName.time,
          key: "time",
          align: "center"
        }
      ];
    }
  },
  methods: {
    getInternation() {
      let Obj = {
        viewType: "Over_Time_Apply",
        beUsed: "1"
      };
      this.spinShow = true;
      axios.post("/International/applySelectViewSet", Obj).then(res => {
        console.log(res);
        this.chName = res.data[0];
        this.enName = res.data[1];
        // console.log(this.chName)
        this.spinShow = false;
      });
    },
    //打开草稿列表
    importCG() {
      this.$refs.cgTem.getInternation();
      this.$refs.cgTem.popShow(
        "JB01",
        JSON.parse(sessionStorage.getItem("userInfo")).userId
      ); //草稿type 操作人
    },
    //保存草稿
    saveCG() {
      this.formItem.applyDate = this.formItem.applyDate
        ? this.date.dateVal(new Date(), "YYYY-MM-DD")
        : null;
      this.formItem.p_begin_dt = this.formItem.p_begin_dt
        ? this.date.dateVal(this.formItem.p_begin_dt, "YYYY-MM-DD")
        : null;
      this.formItem.p_end_dt = this.formItem.p_end_dt
        ? this.date.dateVal(this.formItem.p_end_dt, "YYYY-MM-DD")
        : null;
      this.$refs.cgPop.getInternation();
      this.$refs.cgPop.popShow("JB01", {
        formItem: this.formItem,
        punishmentData: this.punishmentData
      }); //草稿type 草稿内容
    },
    //导入草稿数据到页面
    getCGDa1(row) {
      var obj;
      obj = JSON.parse(row.draftContent);
      this.formItem = obj.formItem;
      this.punishmentData = obj.punishmentData;
      this.$refs["formItem"].fields.forEach(e => {
        if (e._props.prop == "p_begin_dt") {
          e.validate();
        }
        if (e._props.prop == "p_end_dt") {
          e.validate();
        }
      });
    },
    getEmpDate() {
      //申请历史
      if (this.isHistory) {
        let arr1 = {
          instanceId: this.getQueryVariable("instanceId"),
          pageNo: this.pageInfo.pageNum,
          pageSize: this.pageInfo.pageSize
        };
        this.spinShow = true;
        axios.post("/overTime/selectOverTimeData", arr1).then(res1 => {
          this.spinShow = false;
          if (res1) {
            this.data1 = res1.logMap;
            res1.tableInfo.data.data.forEach(item => {
              if (item.att_datetime) {
                item.att_datetime = this.date.dateVal(
                  item.att_datetime,
                  "YYYY-MM-DD HH:mm"
                );
                item.date = item.att_datetime.slice(0, 10);
                item.time = item.att_datetime.slice(12);
              }
            });
            this.punishmentData = res1.tableInfo.data.data;
            this.total = Number(res1.tableInfo.data.pageInfo.total);
            this.formItem = res1.basicInfo;
            this.formItem.applyDate = this.date.dateVal(
              res1.basicInfo.createTime,
              "YYYY-MM-DD"
            );
            this.$set(this.formItem, "userName", res1.basicInfo.applyName);
            this.$set(
              this.formItem,
              "positionName",
              res1.basicInfo.applyPositionName
            );
            this.$set(this.formItem, "p_begin_dt", res1.basicInfo.pbeginDt);
            this.$set(
              this.formItem,
              "p_begin_tm",
              this.date.dateVal(res1.basicInfo.pbeginTm, "HH:mm")
            );
            this.$set(this.formItem, "p_end_dt", res1.basicInfo.pendDt);
            this.$set(
              this.formItem,
              "p_end_tm",
              this.date.dateVal(res1.basicInfo.pendTm, "HH:mm")
            );
            this.$forceUpdate();
          }
        });
      } else {
        let arr = {
          serialnumber: JSON.parse(window.sessionStorage.getItem("userInfo"))
            .serialnumber
        };
        axios.post("/overTime/selectOverTimeUser", arr).then(res => {
          if (res) {
            this.formItem = res;
            this.formItem.applyDate = this.date.dateVal(
              new Date(),
              "YYYY-MM-DD"
            );
            this.$set(
              this.formItem,
              "applyUserId",
              JSON.parse(window.sessionStorage.getItem("userInfo")).serialnumber
            );
            // this.$set(this.formItem, "applyType", "1");
          }
        });
      }
    },
    getDateChange() {
      if (
        this.formItem.p_begin_dt &&
        this.formItem.p_end_dt &&
        this.formItem.p_begin_tm &&
        this.formItem.p_end_tm
      ) {
        let obj = {
          pageNo: this.pageInfo.pageNum,
          pageSize: this.pageInfo.pageSize,
          pBeginDt: this.date.dateVal(this.formItem.p_begin_dt, "YYYY-MM-DD"),
          pEndDt: this.date.dateVal(this.formItem.p_end_dt, "YYYY-MM-DD"),
          pBeginTm:
            this.date.dateVal(this.formItem.p_begin_dt, "YYYY-MM-DD") +
            " " +
            this.formItem.p_begin_tm,
          pEndTm:
            this.date.dateVal(this.formItem.p_end_dt, "YYYY-MM-DD") +
            " " +
            this.formItem.p_end_tm,
          applySerialnumber: JSON.parse(
            window.sessionStorage.getItem("userInfo")
          ).serialnumber
        };
        this.loading = true;
        axios.post("/overTime/overTimeApplyTableInfo", obj).then(res => {
          if (res.data.length > 0) {
            res.data.forEach(item => {
              if (item.att_datetime) {
                item.att_datetime = this.date.dateVal(
                  item.att_datetime,
                  "YYYY-MM-DD HH:mm"
                );
                item.date = item.att_datetime.slice(0, 10);
                item.time = item.att_datetime.slice(12);
              }
            });
          }
          this.punishmentData = res.data;
          this.total = Number(res.pageInfo.total);
          this.loading = false;
        });
      }
    },
    getOverTimeHour() {
      if (
        this.formItem.p_begin_dt &&
        this.formItem.p_end_dt &&
        this.formItem.p_begin_tm &&
        this.formItem.p_end_tm
      ) {
        let obj1 = {
          pBeginTm:
            this.date.dateVal(this.formItem.p_begin_dt, "YYYY-MM-DD") +
            " " +
            this.formItem.p_begin_tm,
          pEndTm:
            this.date.dateVal(this.formItem.p_end_dt, "YYYY-MM-DD") +
            " " +
            this.formItem.p_end_tm,
          applySerialnumber: JSON.parse(
            window.sessionStorage.getItem("userInfo")
          ).serialnumber
        };
        axios.post("/overTime/overTimeCalculation", obj1).then(res => {
          if (res) {
            this.$set(this.formItem, "overTimeLength", res.overTimeLength);
          }
        });
      } else {
        this.$Message.error("请填写预定加班开始时间/结束时间！");
      }
    },
    pageChange(val) {
      this.pageInfo.pageNum = val;
      this.getDateChange();
    },
    submitt() {
      this.$refs["formItem"].validate(valid => {
        if (valid) {
          this.$Modal.confirm({
            title:
              this.lang == "zh"
                ? this.chName.suresubmit
                : this.enName.suresubmit,
            content: "",
            okText:
              this.lang == "zh" ? this.chName.confirm : this.enName.confirm,
            cancelText:
              this.lang == "zh" ? this.chName.cancel : this.enName.cancel,
            onOk: () => {
              // this.prevent = true;
              this.handle();
            },
            onCancel: () => {}
          });
        }
      });
    },
    handle() {
      this.p_begin_tm =
        this.date.dateVal(this.formItem.p_begin_dt, "YYYY-MM-DD") +
        " " +
        this.formItem.p_begin_tm;
      this.p_end_tm =
        this.date.dateVal(this.formItem.p_end_dt, "YYYY-MM-DD") +
        " " +
        this.formItem.p_end_tm;
      let arr = [
        {
          objData1: {
            ...this.formItem,
            apply_serialnumber: this.formItem.serialnumber,
            apply_user_id: JSON.parse(window.sessionStorage.getItem("userInfo"))
              .userId,
            apply_name: this.formItem.userName,
            apply_position_name: this.formItem.positionName,
            apply_position: this.formItem.positionId,
            p_begin_dt: this.date.dateVal(
              this.formItem.p_begin_dt,
              "YYYY-MM-DD"
            ),
            p_end_dt: this.date.dateVal(this.formItem.p_end_dt, "YYYY-MM-DD"),
            p_begin_tm: this.date.dateVal(this.p_begin_tm, "YYYY-MM-DD HH:mm"),
            p_end_tm: this.date.dateVal(this.p_end_tm, "YYYY-MM-DD HH:mm"),
            ot_type1: this.formItem.otType1, //加班别1
            ot_type2: this.formItem.otType2, //加班别2
            //ot_typeName1:,  //加班别名
            // is_late: this.formItem.applyType, //是否过期补
            over_time_length: this.formItem.overTimeLength, //加班内容
            nvchr1: this.formItem.nvchr1, //加班内容
            nvchr2: this.formItem.nvchr2, //补申请原因
            be_agent: 0 //是否代理申请
          },
          stringData1: "JB01",
          stringData4: JSON.parse(window.sessionStorage.getItem("userInfo"))
            .userId,
          stringData10: this.formItem.userName,
          type: "B31"
        }
      ];
      let obj = {
        pBeginDt: this.date.dateVal(this.formItem.p_begin_dt, "YYYY-MM-DD"),
        pBeginTm: this.date.dateVal(this.p_begin_tm, "YYYY-MM-DD HH:mm"),
        pEndDt: this.date.dateVal(this.formItem.p_end_dt, "YYYY-MM-DD"),
        pEndTm: this.date.dateVal(this.p_end_tm, "YYYY-MM-DD HH:mm"),
        applySerialnumber: this.formItem.serialnumber,
        overTimeLength: this.formItem.overTimeLength
      };
      axios.post("/overTime/overTimeCheck", obj).then(res1 => {
        if (res1) {
          this.spinShow = true;
          axios.post("/process/execute", arr).then(res => {
            if (res) {
              this.$Message.info(this.$t("sbumit_Success"));
              this.$router.push(
                "/479EB7C68FD1C711E1668077E8206CA1/A3FFBEBFDB713E27"
              );
            }
            this.spinShow = false;
          });
        }
      });
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
    returnPage() {
      if (this.isHistory) {
        this.$router.push("/EE8D3DF28FEFA1026138E1506FB19594/A3FFBEBFDB713E27");
      } else {
        this.$router.go(-1);
      }
    }
  }
};
</script>

<style scoped>
.titleDistance {
  margin: 30px 30px 0 30px;
}
.ivu-input-search {
  cursor: pointer;
  padding: 0 16px !important;
  color: #000 !important;
  background: #f8f8f9 !important;
  border-color: #dcdee2 !important;
  transition: all 0.2s ease-in-out;
  position: relative;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/process/Apply/OverTimeApply.vue